import type { RenderItemProps } from '@/components/StructuredVirtualList'

import { RoadSegmentItem } from './RoadSegmentItem'

type Props = RenderItemProps<'roadSegments'>

export function Item(props: Props) {
  return props.type === 'item' ? <RoadSegmentItem {...props} /> : null
}
